<template>
  <b-modal 
    id="modal-1"
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    :ok-title="btnTitle"
    hide-footer
    cancel-title="Отмена"
    cancel-variant="light"
    footer-class="justify-content-between"
  >
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form ref="form" @submit.stop.prevent="handleSubmit(submit)">
        <div class="d-flex">
          <validation-provider
            name="Имя"
            rules="alpha_spaces|required"
            v-slot="validationContext"
            class="mr-2 w-100"
          >
            <b-form-group label="Имя *" label-for="firstName">
              <b-form-input id="firstName"
                type="text"
                v-model="form.firstName"
                :state="getValidationState(validationContext)">
              </b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Фамилия"
            rules="alpha_spaces|required"
            v-slot="validationContext"
            class="ml-2 mr-2 w-100"
          >
            <b-form-group label="Фамилия *" label-for="lastName">
              <b-form-input id="lastName"
                type="text"
                v-model="form.lastName"
                :state="getValidationState(validationContext)">
              </b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>

        <div class="d-flex">
          <b-form-group label="E-mail" label-for="email" class="mr-2 w-100">
            <b-form-input id="email"
              type="text"
              disabled
              v-model="form.email">
            </b-form-input>
          </b-form-group>
          <validation-provider
            name="Мобильный телефон"
            :rules="{ required: true }"
            v-slot="validationContext"
            class="ml-2 mr-2 w-100"
          >
            <b-form-group label="Мобильный телефон *" label-for="phone">
              <b-form-input id="phone"
                type="text"
                v-model="form.phone"
                :state="getValidationState(validationContext)">
              </b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>

        <div class="d-flex">
          <div class="row mr-2 w-100">
            <div class="col-md-12">
              <label for="">Дата рождения *</label>
            </div>
            <div class="col-md-4">
              <validation-provider
                name="День"
                :rules="{ required: true }"
                v-slot="validationContext"
                class="mr-2 w-100"
              >
                <b-form-group label="" class="mr-3 w-100">
                  <b-form-select v-model="form.day" class="" :state="getValidationState(validationContext)">
                    <option :value="null" disabled>День</option>
                    <option v-for="option in dayOptions" :value="option" :key="option">{{ option }}</option>
                  </b-form-select>
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>
            <div class="col-md-4 px-md-0">
              <validation-provider
                name="Месяц"
                :rules="{ required: true }"
                v-slot="validationContext"
                class="mr-2 w-100"
              >
                <b-form-group label="" class="mr-3 w-100">
                  <b-form-select v-model="form.month" class="" :state="getValidationState(validationContext)">
                    <option :value="null" disabled>Месяц</option>
                    <option v-for="option in monthOptions" :value="option.value" :key="option.value">{{ option.text }}</option>
                  </b-form-select>
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>
            <div class="col-md-4">
              <validation-provider
                name="Год"
                :rules="{ required: true }"
                v-slot="validationContext"
                class="mr-2 w-100"
              >
                <b-form-group label="" class="mr-3 w-100">
                  <b-form-select v-model="form.year" class="" :state="getValidationState(validationContext)">
                    <option :value="null" disabled>Год</option>
                    <option v-for="option in yearOptions" :value="option" :key="option">{{ option }}</option>
                  </b-form-select>
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>
          </div>

          <validation-provider
            name="Пол"
            :rules="{ required: true }"
            v-slot="validationContext"
            class="ml-3 w-100"
          >
            <b-form-group label="Пол *" label-for="gender">
              <b-form-radio-group
                id="gender"
                v-model="form.gender"
                :options="genderOptions"
                buttons
                button-variant="light"
                name="radios-btn-default"
                :state="getValidationState(validationContext)"
              ></b-form-radio-group>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
        <b-button type="submit" variant="success" size="lg" block>
          Сохранить
        </b-button>
      </b-form>
    </validation-observer>
    <b-button type="submit" variant="light" size="lg" block @click="hideModal" class="mt-2">
      Отмена
    </b-button>
  </b-modal>
</template>

<script>
import { generateArrayOfYears, generateArrayOfNumbers, generateArrayOfMonths } from '@/services/utils'
import { mapState } from 'vuex'

export default {
  props: {
    item: [Object]
  },
  data () {
    return {
      form: {
        firstName: null,
        lastName: null,
        gender: 'male',
        isStudent: null,
        email: null,
        phone: null,
        onboardingComplete: true,
        day: null,
        month: null,
        year: null
      },
      yearOptions: generateArrayOfYears(),
      dayOptions: generateArrayOfNumbers(32),
      monthOptions: generateArrayOfMonths()
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      genderOptions: state => state.auth.genderOptions
    }),
    title () {
      if (this.item) {
        return 'Редактирование профиля'
      } else {
        return 'Создать тренера'
      }
    },
    btnTitle () {
      if (this.item) {
        return 'Сохранить'
      } else {
        return 'Создать'
      }
    }
  },
  methods: {
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    submit () {
      const { form } = this
      this.$store.dispatch('UPDATE_PROFILE', { form, id: this.item.id }).then((response) => {
        this.submitted = true
        this.$emit('update')
        this.$store.dispatch('GET_USER')
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
      }, error => {
        console.log(error)
      })
    },
    resetModal () {
      this.form.firstName = null
      this.form.lastName = null
      this.form.gender = 'male'
      this.form.isStudent = null
      this.form.email = null
      this.form.phone = null
      this.form.onboardingComplete = true
      this.form.day = null
      this.form.month = null
      this.form.year = null
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.form.firstName = this.item.firstName
        this.form.lastName = this.item.lastName
        this.form.gender = this.item.gender ? this.item.gender : 'male'
        this.form.isStudent = this.item.isStudent ? this.item.isStudent : false
        this.form.email = this.item.email
        this.form.phone = this.item.phone ? this.item.phone : null
        this.form.onboardingComplete = this.item.onboardingComplete ? this.item.onboardingComplete : true
        this.form.day = this.item.day ? this.item.day : null
        this.form.month = this.item.day ? this.item.day : null
        this.form.year = this.item.year ? this.item.year : null
      }
      this.$refs['modal'].show()
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
  }
}
</script>